import { Route } from '@angular/router';
import { SubscriptionComponent } from './subscription.component';

export const SubscriptionRoutes: Route[] = [
  {
    path: 'subscription',
    component: SubscriptionComponent
  },
  {
    path: 'account/subscription',
    component: SubscriptionComponent
  },
];
